module.exports = __webpack_public_path__ + "static/media/chirag_ingale.bdd42269.png";